import React from "react";
import { withAppState } from "../../state";
import { i18n } from "../../services/i18nService";
import {
  ButtonModalStyled,
  ThankYouPageStyled,
  ThankYouContainerStyled,
  IconStyled,
  HeadingStyled
} from "./styles/Styled";
import { withFocusable } from "../../services/visualLibraryService";
import { trackPage } from "../../services/analyticsService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { routes } from "../../routes";

const PAGE = "thankYou";
const ButtonModalFocus = withFocusable(ButtonModalStyled);
const startWatchingFocusPath = "startWatchingVoucherModal_passThru";

class ThankYouPage extends React.Component {
  constructor(props) {
    super(props);
    this.onBack = this.onBack.bind(this);
    this.redirectToHome = this.redirectToHome.bind(this);
  }

  componentDidMount() {
    trackPage(PAGE);
    this.props.onRef && this.props.onRef(this);
  }

  redirectToHome() {
    let path = routes.home;
    redirectTo.call(this, path, null, historyMethods.REPLACE);
  }

  onBack() {
    this.redirectToHome();
    return true;
  }

  render() {
    const {
      location: { state }
    } = this.props;
    return (
      <ThankYouPageStyled background="http://mena-img-cdn-lb.aws.playco.com/prd-peg-data/default/bigscreen/images/tizen/samsung-evoucher/samsungEvoucherThanksCover.jpg">
        <ThankYouContainerStyled>
          <IconStyled name="checkboxChecked" />
          {state && state.fromSignup && <HeadingStyled rank={1} text={i18n.get("pages.thankYou.welcome")} />}
          <HeadingStyled rank={1} text={i18n.get("pages.thankYou.samsungGreetings")} />
          <ButtonModalFocus
            label={i18n.get("pages.thankYou.startWatching")}
            focusPath={startWatchingFocusPath}
            onEnterPress={this.redirectToHome}
            onMouseUp={this.redirectToHome}
            dataSnUp={""}
            dataSnDown={""}
            dataSnLeft={""}
            dataSnRight={""}
          />
        </ThankYouContainerStyled>
      </ThankYouPageStyled>
    );
  }
}

export default withAppState(ThankYouPage);
